const checkViewportChange = queries => {
  var defaultQueries = {
    mobile: '(max-width: 568px)',
    tablet: '(min-width: 569px) and (max-width: 768px)',
    tabletLarge: '(min-width: 769px) and (max-width: 959px)',
    desktop: '(min-width: 960px)'
  };

  if (!queries || typeof queries !== 'object') {
    queries = {...defaultQueries};
  }

  var devices = {};
  Object.keys(queries).forEach(function(key, index) {
    devices[this[key].replace(/\s+/g, '')] = key;
  }, queries);

  var checkViewport = function(mediaQueryList, deviceName) {
    if (mediaQueryList.matches) {
      var media = mediaQueryList.media.replace(/\s+/g, '');

      document.documentElement.setAttribute('data-device', deviceName);

      var event = new CustomEvent('changeMatchMedia', {
        detail: {
          device: deviceName
        }
      });
      document.dispatchEvent(event);
    }
  };

  var addEvent = function(mediaQueryList, deviceName) {
    if ('addEventListener' in mediaQueryList) {
      mediaQueryList.addEventListener('change', () => checkViewport(mediaQueryList, deviceName));
    } else {
      mediaQueryList.addListener(() => checkViewport(mediaQueryList, deviceName));
    }
  };

  Object.keys(queries).forEach(function(deviceName, index) {
    var mediaQueryList = window.matchMedia(this[deviceName]);
    checkViewport(mediaQueryList, deviceName);
    addEvent(mediaQueryList, deviceName);
  }, queries);
};

export default checkViewportChange;
